export default "__VITE_ASSET__u$M9mtGX__"